var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-header"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('h1',{staticClass:"text"},[_vm._v("叫-☆都哥☆")]),_vm._v(" "),_c('div',{staticClass:"mine",on:{"click":_vm.showInfor}},[_c('i',{staticClass:"icon-mine"})]),_vm._v(" "),_c('showinfor',{ref:"showInfor"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100605c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/m-header/m-header.vue
// module id = null
// module chunks = 